<script>
import NewRole from "./NewRole";
import NewDonamaker from "./NewDonamaker";
import Pagination from "@/components/_Shared/Pagination";
import PreloaderTable from "@/components/_Shared/PreloaderTable";

import { mapState, mapActions } from "vuex";

export default {
  title: "Donamakers",

  data() {
    return {
      newRole: false,
      newDonamaker: false,
      search: ""
    };
  },

  components: {
    NewRole,
    NewDonamaker,
    Pagination,
    PreloaderTable
  },

  computed: {
    ...mapState("donamakers", [
      "list",
      "preloader",
      "pagination",
      "sort",
      "text_search"
    ])
  },

  methods: {
    ...mapActions("donamakers", [
      "listAll",
      "setCurrentPage",
      "setSort",
      "setTextSearch"
    ]),
    input(value) {
      this.setCurrentPage(value);
    }
  },

  mounted() {
    if (!this.list || !this.list.length) this.listAll();
  },

  watch: {
    text_search(text_search) {
      this.search = text_search;
    }
  }
};
</script>

<template>
  <div class="box">
    <div class="title">DONAMAKERS</div>

    <div class="buttons-filters">
      <div class="new-group" @click="newDonamaker = !newDonamaker">
        <img src="../../../static/plus.svg" /> Cadastrar novo donamaker
      </div>

      <v-layout align-center justify-end row fill-height wrap>
        <input
          type="text"
          v-model="search"
          @keyup.enter="setTextSearch(search)"
          placeholder="buscar"
          class="with-icon icon-search sm text-lowercase"
        />
        <v-btn
          small
          class="primary text-lowercase"
          @click="setTextSearch(search)"
        >
          <span>buscar</span>
        </v-btn>
      </v-layout>
    </div>

    <transition name="fade" mode="out-in">
      <PreloaderTable v-if="preloader" />
      <div key="1" v-else class="table">
        <table>
          <thead>
            <tr>
              <th
                :class="{ sorting: sort === 'first_name' }"
                @click="setSort('first_name')"
              >
                Nome
              </th>
              <th>Cidade</th>
              <th
                :class="{ sorting: sort === 'email' }"
                @click="setSort('email')"
              >
                E-mail
              </th>
              <th
                :class="{ sorting: sort === 'occupation' }"
                @click="setSort('occupation')"
              >
                Cargo
              </th>
            </tr>
          </thead>

          <tbody>
            <tr v-for="donamaker in list" :key="donamaker.id">
              <td>
                <div class="with-image">
                  <img
                    :src="donamaker.profile.profile_picture"
                    :alt="donamaker.first_name"
                  />
                  {{ donamaker.first_name + " " + donamaker.last_name }}
                </div>
              </td>
              <td>{{ donamaker.profile.city_name }}</td>
              <td>{{ donamaker.email }}</td>
              <td>{{ donamaker.occupation }}</td>
            </tr>
          </tbody>
        </table>

        <div class="text-xs-center pt-2">
          <v-pagination
            v-model="pagination.current"
            :total-visible="7"
            :length="pagination.totalPages"
            @input="input"
            circle
          ></v-pagination>
        </div>
      </div>
    </transition>

    <NewRole v-show="newRole" @close="newRole = false" @refresh="listAll()" />
    <NewDonamaker
      v-show="newDonamaker"
      @close="newDonamaker = false"
      @refresh="listAll()"
    />
  </div>
</template>

<div class="new-group" @click="newDonamaker = !newDonamaker">
        <img src="../../../static/plus.svg" /> Cadastrar novo donamaker
      </div>
<style scoped></style>



// WEBPACK FOOTER //
// src/components/Donamakers/Index.vue